import * as requestFromServer from "./planUsageLogCrud";
import { planUsageLogSlice, callTypes } from "./planUsageLogSlice";
import { actions as auth } from "../../Auth/_redux/authRedux";
import { toastOption } from "../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = planUsageLogSlice;

export const fetchPlanUsageLogs = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findPlanUsageLog(queryParams)
    .then((response) => {
      const {
        data: { total_items, items },
      } = response.data;
      dispatch(actions.planUsageLogsFetched({ total_items, items }));
    })
    .catch((error) => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
